export default import.meta.ROLLDOWN_FILE_URL_vbqtqBA2BzbG9TS_Py1gsg